import { atom, atomFamily } from "recoil";

import { RydeUiUnit } from "../../models";

export const apiDataFetchingErrorsAtom = atom<string[] | undefined>({
  key: "apiDataFetchingErrorsAtom",
  default: undefined,
});

//TODO no usages of this, ask to delete
export const apiBackgroundLoadingErrorsAtom = atom<string[] | undefined>({
  key: "apiBackgroundLoadingErrorsAtom",
  default: undefined,
});

export const errorsCrudContentAtomFamily = atomFamily<
  string[] | undefined,
  RydeUiUnit
>({
  key: "errorsCrudContentAtomFamily",
  default: () => undefined,
});

export const archiveRelationErrorAtomFamily = atomFamily<boolean, RydeUiUnit>({
  key: "archiveRelationErrorAtomFamily",
  default: () => false,
});
